<div *ngIf="mailToRegister != ' ' || showForgotPwd || !enableRegister" class="flexCenter">
    <div *ngIf="!showForgotPwd" class="boxShadow loginTab">
        <h1 style="text-align: center;">
            {{"Login" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Login"}}</h1>
        <app-gip-user-logon></app-gip-user-logon>
        <p *ngIf="mailToRegister != ' ' && enableRegister">
            <a [href]="mailToRegisterValue" class="flexCenter">{{"Register" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Login"}}</a>
        </p>
        <p *ngIf="enableForgotPassword" (click)="changeShowForgotPwd()" style="cursor:pointer; color:blue; text-align-last: center">
            {{'ForgotPassPrefix' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</p>
    </div>
    <div *ngIf="showForgotPwd" class="boxShadow loginTab">
        <app-gip-user-forgot-pwd (moveToLogin)="changeShowForgotPwd()"></app-gip-user-forgot-pwd>
        <button mat-raised-button style="margin-top: 10px;" (click)="changeShowForgotPwd()">{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    </div>
</div>

<div *ngIf="!showForgotPwd && mailToRegister == ' ' && enableRegister" class="loginRegisterTab flexCenter">
    <mat-tab-group mat-stretch-tabs class="boxShadow" [selectedIndex]="selected" (selectedIndexChange)="setSelected($event)">
        <mat-tab [label]="this.translateResourceDefinition.transform('Login', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'LOGIN')">
            <br>
            <app-gip-user-logon></app-gip-user-logon>
            <p *ngIf="enableForgotPassword" (click)="changeShowForgotPwd()" style="cursor:pointer; color:blue; text-align-last: center">
                {{'ForgotPassPrefix' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
            </p>
        </mat-tab>
        <mat-tab [label]="translateResourceDefinition.transform('Register', this.resourceDefinition, 'KEY_NAME', 'LONG_TEXT', 'REGISTER')">
            <br>
            <app-gip-user-register-form [selectedTab]="selected" (moveToLogin)="moveToLoginFromRegister()"></app-gip-user-register-form>
        </mat-tab>
    </mat-tab-group>
</div>